import { render, staticRenderFns } from "./borrowingManager.vue?vue&type=template&id=5cb2485e&scoped=true&"
import script from "./borrowingManager.vue?vue&type=script&lang=js&"
export * from "./borrowingManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2485e",
  null
  
)

export default component.exports